export default __webpack_public_path__ + "static/media/logo.3f9956a1.png";